module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "label1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('strong', [_vm._v("CHAPTER 1")])]), _vm._v(" "), _c('p', {
    staticClass: "h3a"
  }, [_c('strong', [_vm._v("THE PHYSICAL GHETTO")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Between 1890 and 1915, the Negro population of Chicago grew from less than fifteen thousand to over fifty thousand. Although this growth was overshadowed by the massive influx of Negroes during and after World War I, this was nevertheless a significant increase. By the eve of World War I, although Negroes were still a minor element in the city’s population, they were far more conspicuous than they had been a generation earlier. The population increase was accompanied by the concentration of Negroes into ever more constricted sections of the city. In the late nineteenth century, while most Negroes lived in certain sections of the South Side, they lived interspersed among whites; there were few all-Negro blocks. By 1915, on the other hand, the physical ghetto had taken shape; a large, almost all-Negro enclave on the South Side, with a similar offshoot on the West Side, housed most of Chicago’s Negroes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Migration was the major factor in the growth of the Negro community, and most migrants were coming from outside of the state. Over 80 per cent of Chicago’s Negro population in 1900 was born in states other than Illinois. The largest portion of these migrants originated in the border states and in the Upper South: Kentucky, and Missouri, in particular, had sent large groups of Negroes to Chicago. The states of the Deep South were, as yet, a secondary source of Chicago’s Negro population; only 17 per cent had come from these states as opposed to 43 per cent from the Upper South. The states located directly south of Chicago supplied a larger segment of the population than the southeastern states, but there were sizable groups born in Virginia and Georgia."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch1fn1",
      "id": "ich1fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the beginning of Chicago’s history, most Negroes had lived on the South Side. As early as 1850, 82 per cent of the Negro population lived in an area bounded by the Chicago River on the "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("north, Sixteenth Street on the south, the South Branch of the river on the west, and Lake Michigan on the east."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch1fn2",
      "id": "ich1fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The famous South Side black belt was emerging—a narrow finger of land, wedged between the railroad yards and industrial plants just west of Wentworth Avenue and the fashionable homes east of Wabash Avenue. By 1900, the black belt stretched from the downtown business district as far south as Thirty-ninth Street. But there were also sizable Negro enclaves, usually of a few square blocks each, in several other sections of the city."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch1fn3",
      "id": "ich1fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" The Thirteenth Ward Negro community stretched along West Lake Street from Ashland to Western. The Eighteenth Ward Negroes lived in the old immigrant neighborhood on the Near West Side near Hull House. On the Near North Side, Negroes had begun to settle in the Italian Seventeenth Ward. And on the South Side, beyond the black belt, communities of upper- and middle-class Negroes had emerged in Hyde Park, Woodlawn, Englewood, and Morgan Park."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch1fn4",
      "id": "ich1fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tcaption",
    staticStyle: {
      "page-break-before": "always"
    }
  }, [_c('a', {
    attrs: {
      "id": "tab1"
    }
  }), _vm._v("TABLE 1")]), _vm._v(" "), _c('p', {
    staticClass: "tcaption1"
  }, [_vm._v("NEGRO POPULATION OF CHICAGO 1850–1930")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0012-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tsourcea"
  }, [_vm._v("SOURCE: "), _c('em', [_vm._v("U.S. Census Reports")]), _vm._v(", 1850–1930.")]), _vm._v(" "), _c('p', {
    staticClass: "tcaption",
    staticStyle: {
      "page-break-before": "always"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "tab2"
    }
  }), _vm._v("TABLE 2")]), _vm._v(" "), _c('p', {
    staticClass: "tcaption1"
  }, [_vm._v("STATE OF BIRTH OF NATIVE NON-WHITES CHICAGO, 1900")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0013-01.jpg",
      "width": "60%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0014-01.jpg",
      "width": "60%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tsourcea"
  }, [_vm._v("SOURCE: "), _c('em', [_vm._v("U.S. Twelfth Census")]), _vm._v(", 1900, vol. 1, "), _c('em', [_vm._v("Population")]), _vm._v(", part 1, pp. 706–25. Derived by adding figures in Tables 31 and 32 and subtracting from figures in Table 30.")]), _vm._v(" "), _c('p', {
    staticClass: "tsource"
  }, [_c('sup', [_vm._v("a")]), _vm._v(" Middle West totals (including Illinois): 10, 276 and 34.5 per cent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite this concentration of Negroes in enclaves, the Negro population of the city was still relatively well distributed in 1900. Nineteen of the city’s thirty-five wards had a Negro population of at least .5 per cent of the total population of the ward and fourteen wards were at least 1 per cent Negro. Only two wards had a Negro population of more than 10 per cent. In 1898, just over a quarter of Chicago’s Negroes lived in precincts that were more than 50 per cent Negro, and over 30 per cent lived in precincts that were at least 95 per cent white."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch1fn5",
      "id": "ich1fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" As late as 1910, Negroes were less highly segregated from native whites than were Italian immigrants."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_24_not#ch1fn6",
      "id": "ich1fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b61a0c06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226160702_11_ch1.vue
// module id = 87
// module chunks = 0